import type { Pipeline } from '@payaca/types/pipelineTypes';
export interface State {
  pipelines: Pipeline[];
  isPerformingPipelineAction: boolean;
}

export enum ActionType {
  REQUEST_GET_ACCOUNT_PIPELINES = 'pipelines.requestGetAccountPipelines',
  GET_ACCOUNT_PIPELINES_SUCCESS = 'pipelines.getAccountPipelinesSuccess',
  GET_ACCOUNT_PIPELINES_FAILURE = 'pipelines.getAccountPipelinesFailure',

  CLEAR_PIPELINES = 'pipelines.clearPipelines',
}

export interface SagaConfig {
  apiBaseurl: string;
  getAuthHeader: () => Promise<string>;
  isNativeApp: boolean;
}
